import React, { createContext } from 'react'

export const GlobalLoadIndicator = createContext();